module.exports = __webpack_public_path__ + "fonts/FuturaPT-MediumObl.61a6e80b.woff2";